export default (props, vars) => props?.['name'] === 'see_below';
